export enum OrderStatus {
  PENDING = 'Pending',
  PAID = 'Paid',
  CANCELLED = 'Cancelled',
  REFUNDED = 'Refunded',
  ERROR = 'Error',
}
